import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, TemplateRef, ViewChild } from '@angular/core';
import { NormalizedHorizontalBarChartData } from '@shared/utils/chart-types';
import { ColorsGraphArray } from '@shared/utils/colors-graph';
import { BarVerticalStackedComponent } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-vertical-stacked-bar',
  templateUrl: './vertical-stacked-bar.component.html'
})
export class VerticalStackedBarComponent implements AfterViewInit {

  @ViewChild('containerRef') containerRef!: ElementRef;
  @ViewChild('chart') chartComponent: BarVerticalStackedComponent;
  @Input() id: string ='vertical-chart';
  @Input() data: NormalizedHorizontalBarChartData[] = [];
  @Input() view: any[] = [500, 230];
  @Input() label: string = '';
  @Input() showXAxis: boolean = true;
  @Input() showYAxis: boolean = true;
  @Input() showLegend: boolean = false;
  @Input() showXAxisLabel: boolean = false;
  @Input() xAxisLabel: string = '';
  @Input() showYAxisLabel: boolean = false;
  @Input() yAxisLabel: string = '';
  @Input() animations: boolean = true;
  @Input() barPadding: number;
  @Input() legendPosition: string = '';
  @Input() legendTitle: string = '';
  @Input() showGridLines: boolean = false;
  @Input() showDataLabel: boolean = false;
  @Input() colorScheme = {
    domain: [...ColorsGraphArray]
  };
  @Input() customTooltip = false;

  tempValues: number[] = [];
  private mutationObserver!: MutationObserver;
  @Input() customTooltipTpl: TemplateRef<any> | null = null;

  constructor(public cdr: ChangeDetectorRef) {
    Object.assign(this.data);
  }

  @HostListener('window:resize')
  resizeChart() {
    if (this.containerRef) {
      const width = this.containerRef.nativeElement.offsetWidth;
      this.view = [width, 300];
    }
  }

  ngAfterViewInit(): void {
    this.formatDataLabels();
  }

  /**
  * Método chamado quando os dados do gráfico são atualizados.
  * Ele garante que os labels de porcentagem sejam formatados corretamente,
  * observando mudanças no gráfico até que os elementos estejam disponíveis.
  */
  onData(): void {
    if (this.chartComponent?.['chartElement']) {
      const chartElement = this.chartComponent['chartElement'].nativeElement;

      this.disconnectPreviousObserver();
      this.setupMutationObserver(chartElement);
    }
  }

  /**
  * Desconecta qualquer MutationObserver anterior para evitar múltiplos observers ativos.
  */
  disconnectPreviousObserver(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  /**
  * Cria e inicia um MutationObserver para observar mudanças no gráfico,
  * formatando os labels assim que eles forem adicionados ao DOM.
  */
  private setupMutationObserver(chartElement: HTMLElement): void {
    this.mutationObserver = new MutationObserver(() => {
      const dataLabelElements = chartElement.querySelectorAll('.textDataLabel');
      if (dataLabelElements.length > 0) {
        this.formatDataLabels();
        this.mutationObserver?.disconnect();
      }
    });

    this.mutationObserver.observe(chartElement, {
      childList: true,
      subtree: true,
    });
  }

  formatDataLabels(): void {
    if (this.chartComponent?.['chartElement']) {
      const dataLabelElements = this.chartComponent['chartElement'].nativeElement.querySelectorAll('.textDataLabel');

      dataLabelElements.forEach((labelElement: SVGTextElement, index: number) => {
        if (this.data && this.data[index] && this.data[index].porcentagem) {
          labelElement.textContent = this.data[index].porcentagem;
        }
      });
    }
  }
}
